// extracted by mini-css-extract-plugin
module.exports = {"about-us":"aboutUs_about-us__UFiGc","picture":"aboutUs_picture__VZ8la","paragraph":"aboutUs_paragraph__8AaOw"};